import React from 'react'
import { LgySection } from 'app/components/util/lgy-section/LgySection'
import JobRuns from './JobRuns'
import JobModificationContainer from 'app/gears/admin/jobs/containers/JobModificationContainer'
import ReactMarkdown from 'react-markdown'
import LgyLoadingFallback from 'app/components/util/lgy-loading-fallback/LgyLoadingFallback'

const JobSummary = ({ job, startJob, userCanStartJobs, isStartingNewJob }) =>
  <LgySection header={`${job.name} Summary`}>
    <JobModificationContainer job={job} />
    <ReactMarkdown source={job.details} />
    <LgyLoadingFallback isLoading={isStartingNewJob}>
      <button type='button' onClick={() => startJob(job.name)} disabled={!userCanStartJobs}>Run {job.name}</button>
    </LgyLoadingFallback>
    <JobRuns job={job} />
  </LgySection>

export default JobSummary